import axios from 'axios'
import config from './config'
import router from '@/router'
import iView from 'iview'

export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseURL,
      headers: config.headers,
      timeout: config.timeout,
      withCredentials: config.withCredentials
    })

    // request 拦截器
    instance.interceptors.request.use(
      config => {
        let token = window.localStorage.getItem('auth_token')
        // 2. 带上token
        if (token) {
          if (config.headers && config.headers.headers) {
            config.headers = config.headers.headers;
          }
          if (!config.headers) {
            config.headers = {};
          }
          config.headers.Authorization = 'Bearer ' + token;
        } else {
          // 重定向到登录页面
          router.push('/login')
        }
        if (config.method === 'post') {
          if (Object.prototype.toString.call(config.data) != '[object FormData]') {
              config.data = {
                ...config.data,
                _t: Date.parse(new Date()) / 1000
              }
          }
        } else if (config.method === 'get') {
          config.params = {
            _t: Date.parse(new Date()) / 1000,
            ...config.params
          }
        }
        return config
      },

      error => {
        // 请求错误时
        console.log('request:', error)
        // 1. 判断请求超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
          console.log('timeout请求超时')
        }
        // 2. 需要重定向到错误页面
        const errorInfo = error.response
        console.log(errorInfo)
        if (errorInfo) {
          error = errorInfo.data  // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status // 404 403 500 ...
          router.push({
            path: `/error/${errorStatus}`
          })
        }
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        iView.Spin.hide()
        let data
        if (response.data.code == 2001) {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('userInformation');
          localStorage.removeItem('permission_token');
          localStorage.removeItem('userRoles');
          // 重定向到登录页面
          router.push('/login')
        } else {
          // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
          if (response.data == undefined) {
            data = JSON.parse(response.request.responseText)
          } else {
            data = response.data
          }
          return data
        }
      },
      err => {
        if (err && err.response) {
          iView.Spin.hide()
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break
            case 401:
              err.message = '未授权，请登录'
              break
            case 403:
              err.message = '拒绝访问'
              break
            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`
              break
            case 408:
              err.message = '请求超时'
              break
            case 500:
              err.message = '服务器内部错误'
              break
            case 501:
              err.message = '服务未实现'
              break
            case 502:
              err.message = '网关错误'
              break
            case 503:
              err.message = '服务不可用'
              break
            case 504:
              err.message = '网关超时'
              break
            case 505:
              err.message = 'HTTP版本不受支持'
              break
            default:
          }
        }
        console.error(err)
        return Promise.reject(err) // 返回接口返回的错误信息
      }
    )

    // 请求处理
    instance(options).then(res => {
      resolve(res)
      return false
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/http/axios.js